<template>
  <div>
    <div class="configure-user">
      <div class="user-details">
        <div class="row search-bar no-gutters align-items-center">
          <!--end of col-->
          <div class="col-6 form-control form-control-lg form-control-borderless">
            <i class="fa fa-search" style="opacity:0.3" aria-hidden="true"></i>
            <input
              class="borderless"
              type="search"
              v-model="searchText"
              placeholder="Search topics or keywords"
            />
          </div>
          <div class="col text-right" style="height:100%">
            <button class="add-user-button" @click="AddUser">+ Add New User</button>
          </div>
        </div>
        <div class="row details-list">
          <table style="width:100%">
            <tr class="table-heading">
              <th>Name</th>
              <th>Username</th>
              <th>Role</th>
              <th>Group Assigned</th>
              <th>Date</th>
              <th></th>
            </tr>
            <tr v-for="(user, index) in displayedUser" class="table-row" :key="index">
              <td>{{user.first_name}} {{user.last_name}}</td>
              <td>{{user.name}}</td>
              <td>{{user.role}}</td>
              <td>{{user.cmdGroups?user.cmdGroups:'N/A'}}</td>
              <td>{{formatDate(user.date)}}</td>
              <td>
                <img
                  class="function-btn"
                  @click="editUser(user.id)"
                  src="../../../assets/icons/config/edit.svg"
                />
                <img
                  class="function-btn"
                  @click="deleteUser(user)"
                  src="../../../assets/icons/config/remove.svg"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.row {
  margin-left: 0;
  margin-right: 0;
}
.configure-user {
  height: calc(100vh - 200px);
  font-family: "Source Sans Pro", sans-serif;
  padding-left: 15px;
}
.form-control-borderless {
  border: none;
  padding-left: 10px;
}

.form-control-borderless:hover,
.form-control-borderless:active,
.form-control-borderless:focus {
  border: none;
  outline: none;
  box-shadow: none;
}
.form-control input {
  margin-left: 10px;
  width: 89%;
}
.borderless {
  border: 0 none;
}
.function-btn {
  margin-left: 30px;
  margin-right: 30px;
  cursor: pointer;
}
.card-unassigned {
  height: 100% !important;
}
.card-unassigned .card-header {
  margin: 0;
  padding: 16px 24px 16px 24px;
  font-weight: 600;
}
.card-unassigned .card-body {
  margin: 0;
  padding: 8px 24px 8px 24px;
}
.card-unassigned .list-group-item {
  padding: 8px 8px 8px 0px;
}
.card-unassigned .list-content {
  vertical-align: text-bottom;
  vertical-align: -moz-middle-with-baseline;
  white-space: nowrap;
  width: calc(100% - 5rem);
  text-overflow: ellipsis;
  overflow: hidden;
}
.unassigned-edit {
  margin: 0px 5px 0px 5px;
  height: 2rem;
}
.details-list {
  margin-top: 15px;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.15);
}
input {
  border: 1px solid black;
}
.search-bar {
  height: 50px;
  padding: 6px 0px 6px 0px;
  display: flex;
  justify-content: space-between;
}
.search-input {
  height: 38px;
  width: 50%;
  background: #f9f9f9;
  border: 1px solid #b4b4b4;
  box-sizing: border-box;
  border-radius: 4px;
  padding-left: 10px;
  color: #b4b4b4;
}
.add-user-button {
  width: 150px;
  background: #24c656;
  border-radius: 4px;
  color: white;
  height: 100%;
}
.table-heading {
  height: 50px;
  background: #f2f2f2;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
}
.table-row {
  background: white;
  height: 40px;
}
td {
  width: 25%;
}
.pages-list {
  position: absolute;
  bottom: 20px;
}
.user-details {
  height: calc(100vh - 182px);
  padding-right: 15px;
}
.page-control,
.page-no {
  margin-right: 30px;
}
img {
  margin-left: 20px;
}
.search-icon {
  position: absolute;
  left: calc(50% - 60px);
  top: 15px;
}
</style>
<script>
const _ = require("lodash");
export default {
  name: "ConfigureUsers",
  data() {
    return {
      searchText: "",
      displayedUser: ""
    };
  },
  computed: {
    assignedUsers() {
      return this.$store.state.availableUsers.reverse();
    }
  },
  watch: {
    searchText(val) {
      if (val == "") {
        this.displayedUser = _.clone(this.assignedUsers);
      } else {
        this.displayedUser = this.assignedUsers.filter(element => {
          return (
            `${element.first_name} ${element.last_name}`
              .toLowerCase()
              .includes(val.toLowerCase()) ||
            element.name.toLowerCase().includes(val.toLowerCase())
          );
        });
      }
    }
  },
  methods: {
    AddUser(obj) {
      this.$router.push("/app/secure/admincenter/create");
    },
    editUser(id) {
      this.$router.push("/app/secure/admincenter/edit/" + id);
    },
    async deleteUser(user) {
      var r = confirm(`delete ${user.name}?`);
      if (r) {
        await this.$store.dispatch("deleteUser", user.id);
        var logData = this.createLogData(user);
        await this.$store.dispatch("AddUserLog", logData);
        await this.$store.dispatch("getUsers");
        this.displayedUser = _.clone(this.assignedUsers);
      }
    },
    createLogData(obj) {
      let user = _.clone(obj);
      var LogData = {
        user: this.$store.state.user,
        collection: "user",
        mode: "delete",
        record: user.id,
        fields: [],
        newValue: [],
        oldValue: []
      };
      delete user.id;
      for (let key in user) {
        LogData.fields.push(key);
        LogData.oldValue.push(user[key]);
      }
      return LogData;
    },
    formatDate(dt) {
      // console.log(dt);
      if (!dt || dt == "") return "N/A";
      var date = new Date(dt);
      var x = date.toDateString().substring(4);
      return x.slice(0, 3) + "," + x.slice(3);
    }
  },
  mounted() {
    this.$store.dispatch("showLoader", false);
  },
  async created() {
    this.$store.commit("changePathLabel", {
      view: "Configure User",
      categories: []
    });
    await this.$store.dispatch("getUsers");
    this.displayedUser = _.clone(this.assignedUsers);
  }
};
</script>
